import { siteMatchesRequestFilters } from "#app/utils/siteMatchesRequestFilters.js";

const accessibilityFilterSiteTypes = new Set([
  "rv",
  "tent",
  "backcountry",
  "group",
  "lodging",
]);

export function getFilteredSiteIds({
  facility,
  siteType,
  maxRVLength = "",
  selectedFilters = [],
  doubleSitePreference = "any",
  accessibilityPreference,
  maxElectric = [],
}) {
  if (!accessibilityPreference) {
    throw new Error("accessibilityPreference is required");
  }

  const selected = new Set(selectedFilters);
  const parseMinimum = (value) => {
    const parsed = parseInt(value);
    return Number.isNaN(parsed) ? null : parsed;
  };
  const criteria = {
    siteType,
    maxRVLength: parseMinimum(maxRVLength),
    maxElectric: parseMinimum(maxElectric),
    isTentOnly: selected.has("isTentOnly"),
    isPullThrough: selected.has("isPullThrough"),
    hasWater: selected.has("hasWater"),
    hasSewer: selected.has("hasSewer"),
    hasElectric: selected.has("hasElectric"),
    isDoubleSite:
      doubleSitePreference === "double"
        ? true
        : doubleSitePreference === "single"
          ? false
          : null,
    isAccessible: !accessibilityFilterSiteTypes.has(siteType)
      ? null
      : accessibilityPreference === "only"
        ? true
        : accessibilityPreference === "exclude"
          ? false
          : null,
  };

  return facility.sites
    .filter((site) => siteMatchesRequestFilters(site, criteria))
    .map((site) => `${site.id}`);
}
